



















































































































































































































































import { Component, Ref, Vue, Emit, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { onlyNumber, timeout } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentBackofficeProcedimentosInternacao extends Vue {
  @Prop({ required: false, default: false }) disabled: boolean

  headerEnabled: any[] = [
    { text: 'Procedimento', class: 'table-headers', align: 'left', sortable: false, value: 'descricao' },
    { text: 'Procedimento Convênio', class: 'table-headers', align: 'center', sortable: false, value: 'procedimentoConvenio' },
    { text: 'Quantidade', class: 'table-headers', align: 'center', sortable: false, value: 'quantidade' },
    { text: '', class: 'table-headers', align: 'center', sortable: false },
  ]

  headerDisabled: any[] = [
    { text: 'Procedimento', class: 'table-headers', align: 'left', sortable: false, value: 'descricao' },
    { text: 'Procedimento Convênio', class: 'table-headers', align: 'center', sortable: false, value: 'procedimentoConvenio' },
    { text: 'Quantidade', class: 'table-headers', align: 'center', sortable: false, value: 'quantidade' },
  ]


  modalProcedimentosInternacao: boolean = false
  loadProcedimentosInternacao: boolean = false
  loadDeleteProcedimentoInternacao: string = ''
  inputSearch: string = ''
  loading: any = {
    searchTipoDeInternacao: false,
    listText: 'Tipo de procedimento não encontrado.',
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get loadingDeleteProcedimentoInternacao() {
    return this.loadDeleteProcedimentoInternacao
  }

  set loadingDeleteProcedimentoInternacao(value: string) {
    this.loadDeleteProcedimentoInternacao = value
  }

  get loadingProcedimentosInternacao() {
    return this.loadProcedimentosInternacao
  }

  set loadingProcedimentosInternacao(value: boolean) {
    this.loadProcedimentosInternacao = value
  }

  get showModalProcedimentosInternacao() {
    return this.modalProcedimentosInternacao
  }

  set showModalProcedimentosInternacao(value: boolean) {
    this.modalProcedimentosInternacao = value
  }

  get getProcedimentosInternacao() {
    return this.getBackofficeGlobalStore.procedimentosInternacaoSelected
  }

  get getProcedimentosInternacaoApi() {
    return this.getBackofficeGlobalStore.procedimentosInternacao
  }

  get getInputSearch() {
    return this.inputSearch
  }

  set getInputSearch(value) {
    this.inputSearch = value
  }

  async removeProcedimento(procedimentoId: string) {
    this.loadingDeleteProcedimentoInternacao = procedimentoId
    const request = await this.getBackofficeGlobalStore.deleteProcedimentoBackoffice(procedimentoId)
    if (request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item removido com sucesso!', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro ao deletar o item.', icon: 'warning', color: '#C62828' })
    }
    this.loadingDeleteProcedimentoInternacao = ''
  }

  addSelected(item) {
    this.procedimentoInternacao = { quantidade: 1, lateralidade: '', ...item }
    this.getShowModalQuantidade = true
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  debounce = _.debounce(input => this.getBackofficeGlobalStore.getProcedimentosInternacaoBackofficeSearch(input), 600)

  search(input) {
    if (this.inputSearch.length === 0 || this.inputSearch.length > 2) {
      this.debounce(this.inputSearch)
    }
  }

  async openModalProcedimentosInternacao() {
    this.loadingProcedimentosInternacao = true
    await this.getBackofficeGlobalStore.getProcedimentosInternacaoBackofficeSearch('')
    this.showModalProcedimentosInternacao = true
    this.loadingProcedimentosInternacao = false
  }

  @Watch('showModalProcedimentosInternacao')
  onChangeShowModalProcedimentosInternacao(value) {
    setTimeout(() => {
      const input = document.querySelector('.procedimentos-internacao-backoffice-input input') as HTMLInputElement
      this.getInputSearch = ''
      if (value) {
        input.focus()
      } else {
        input.blur()
      }
    }, 100)
  }

  /**
   * Modal Quantidade
   */

  procedimento: any = {}
  loadSaveProcedimentoInternacao: boolean = false

  get procedimentoInternacao() { return this.procedimento }
  set procedimentoInternacao(value: any) { this.procedimento = value }

  get loadingSaveProcedimentoInternacao() { return this.loadSaveProcedimentoInternacao }
  set loadingSaveProcedimentoInternacao(value: boolean) { this.loadSaveProcedimentoInternacao = value }

  $refs!: {
    quantidadeForm: any,
  }

  modalQuantidade: boolean = false

  get getShowModalQuantidade() { return this.modalQuantidade }
  set getShowModalQuantidade(value: boolean) { this.modalQuantidade = value }

  closeModalQuantidade() {
    this.getShowModalQuantidade = false
    this.procedimentoInternacao = {}
    this.$refs.quantidadeForm.reset()
    this.$refs.quantidadeForm.resetValidation()
  }

  quantidadeRules: any = {
    valid: true,
    quantidade: [
      v => !!v || 'Campo obrigatório.',
    ],
    lateralidade: [],
  }

  async save() {
    this.loadingSaveProcedimentoInternacao = true
    const params: any = { ...this.procedimentoInternacao }

    Object.entries(params).forEach(([key, value]) => {
      // @ts-ignore
      if (['', null, 0, undefined].includes(value)) {
        delete params[key]
      }
    })

    const request = await this.getBackofficeGlobalStore.postProcedimentoBackoffice(params)
    if (request.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Item inserido com sucesso!', icon: 'done', color: '#2E7D32' })
      this.procedimentoInternacao = {}
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro ao inserir o item.', icon: 'warning', color: '#C62828' })
    }
    this.loadingSaveProcedimentoInternacao = false
    this.getShowModalQuantidade = false
  }
}
